// Trazo de 16×16 del lienzo pintado con currentColor, para que el color salga del token (text-ink,
// text-primary) y no de un hex. Lo comparten Poderes_Demo y la sección de precios.

export const TRAZO_CHECK = 'M3 8.5l3 3 7-7';

interface PropiedadesIconoTrazo {
    trazo: string;
    tamano: number;
    grosor?: number;
    className?: string;
}

export default function IconoTrazo({ trazo, tamano, grosor = 1.6, className }: PropiedadesIconoTrazo) {
    return (
        <svg
            width={tamano}
            height={tamano}
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth={grosor}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className={className}
        >
            <path d={trazo} />
        </svg>
    );
}
